<template>
  <div class="bgFrame">
    <div class="box">
      <div class="bottomText">
        Copyright © 2022 NuMatch. Powered by CRV Consultants ( Hong Kong ) Ltd.
        All rights reserved. | Cookies Policy
      </div>
      <!-- <div style="width: calc(100% / 1080 * 64)"></div> -->
      <!-- <div
        v-for="(item, index) in serviceList"
        :key="index"
        style="display: flex;display: none;"
      >
        <img @click="shareControl(index)" :src="item.src" class="shareLogo" />
        <div style="width: 11px; height: 2px"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "App",
  components: {},
  setup() {
    onMounted(() => {});
    const serviceList = ref([
      { src: require("../../assets/facebook.png"), link: "" },
      { src: require("../../assets/instagram.png"), link: "" },
      { src: require("../../assets/youtube.png"), link: "" },
      { src: require("../../assets/whatsapp.png"), link: "" },
      { src: require("../../assets/wechat.png"), link: "" },
      { src: require("../../assets/tiktok.png"), link: "" },
    ]);
    const shareControl = (index) => {
      window.location.href = serviceList.value[index].link;
    };
    return {
      shareControl,
      serviceList,
    };
  },
};
</script>

<style lang="less" scoped>
.bgFrame {
  position: relative;
  width: 100%;
  padding-top: 7%;
}
.box {
  position: absolute;
  height: 100%;
  top: 0px;
  width: 100%;
  background: #FDFDFE;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottomText {
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #333333;
}
.shareLogo {
  width: 18px;
  height: 18px;
}
</style>
